<template>
	<div class="flex gap-4">
		<NuxtLink href="/app">
			<Btn class="border-2 border-foreground border-solid bg-foreground px-5 py-1 text-background hover:bg-foreground/70">
				رایگان شروع کن !
			</Btn>
		</NuxtLink>

		<NuxtLink href="/#features">
			<Btn class="gap-2 border-2 border-foreground border-solid px-3 py-1">
				<Icon
					name="i-heroicons:arrow-down-16-solid"
					class="size-5" />

				مطالعه بیشتر
			</Btn>
		</NuxtLink>
	</div>
</template>
